<div>
    <app-loader [loadingMessage]='loadingMessage'></app-loader>
</div>